import { call, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { fetchMt5SReportDone } from '../../api/api';
import { loadReportDoneSuccess, loadReportDoneFailure } from './actions';
import { LoadRequestAction } from '../../types/reportDone5SAudit';

export function* loadReportDoneSaga(action: LoadRequestAction) {
  const { filters } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(fetchMt5SReportDone, filters);
    if (response.data?.success) {
      yield put(loadReportDoneSuccess(response.data.data));
    } else {
      yield put(loadReportDoneFailure(response.data?.error || 'Не удалось загрузить отчет'));
    }
  } catch (error) {
    const errorMessage = (error as any)?.message || 'Ошибка загрузки отчета';
    yield put(loadReportDoneFailure(errorMessage));
  }
}
